module.exports = __webpack_public_path__ + "static/media/Babysitter.8b16e085.png";